import { getAPIHeaders } from 'api';
import { strings } from 'common';
import { merge } from 'lodash';

export async function configuredFetch(path: string, options: any = {}) {
  const headers = await getAPIHeaders(options.method, options.headers);
  // eslint-disable-next-line no-undef
  const requestOptions: RequestInit = merge<RequestInit, RequestInit>(
    headers.options,
    options
  );

  const response = await fetch(`${headers.host}${path}`, requestOptions);

  if (!response.ok) {
    throw new Error(`Network response was not ok: ${response.status}`);
  }

  return response;
}

export async function configuredFetchText(path: string): Promise<string> {
  const response = await configuredFetch(path, { 'content-type': 'text/html' });
  return response.text();
}

export async function apiBlobFetcher(path: string) {
  const data = await configuredFetch(path, {
    'content-type': 'application/pdf',
  })
    .then((res) => res.blob())
    .catch((error) => {
      if (error?.message?.indexOf(404)) {
        throw new Error(strings.VEHICLE_NOT_FOUND_ALERT_MESSAGE);
      }
      throw new Error(strings.WINDOW_STICKER_SERVICE_NOT_AVAILABLE);
    });
  return URL.createObjectURL(data);
}
